import { Helmet } from 'react-helmet'

export default function MutinyTag() {
  return (
    <Helmet>
      <script src="https://client-registry.mutinycdn.com/personalize/client/432f7b6d9fb1eaec.js" />
    </Helmet>
  )
}
